import axios from "axios";
import { userServiceUrl } from "../../Config/config";

export const SESSION_REQUEST = "SESSION_REQUEST";
export const SESSION_SUCCESS = "SESSION_SUCCESS";
export const SESSION_FAILURE = "SESSION_FAILURE";

const createAction = (type, payload = null) => ({ type, payload });

export const Initiatestartsession = (id) => async (dispatch) => {
  dispatch(createAction(SESSION_REQUEST));
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      const errorMessage = "No token found";
      dispatch(createAction(SESSION_FAILURE, errorMessage));
      throw new Error(errorMessage);
    }

    const response = await axios.get(
      `${userServiceUrl}/initiate-start-session/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );


    if (response.data) {
      dispatch(createAction(SESSION_SUCCESS, response.data));
    } else {
      const errorMessage = "Invalid response structure";
      dispatch(createAction(SESSION_FAILURE, errorMessage));
      throw new Error(errorMessage);
    }

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
    dispatch(createAction(SESSION_FAILURE, errorMessage));
    console.error(error);
    throw new Error(errorMessage);
  }
};
